import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class LanguageService {
  private language: String = 'be_nl';
  languageChanged = new Subject<String>();

  setLanguage(language: String) {
    console.log('Language changed to : ' + language);
    this.language = language;
    this.languageChanged.next(this.language);
  }

  getLanguage() {
    return this.language.substr(this.language.lastIndexOf('_') + 1);
  }

  getLanguageCode() {
    return this.language;
  }

  isLanguage(expectedLanguage: String): boolean {
    return this.language.endsWith('_' + expectedLanguage);
  }
}
